module.exports = __webpack_public_path__ + "static/media/tracker_logo.5e73930e.png";